import { defineComponent as _defineComponent } from 'vue'
import { inject, Ref, ref } from 'vue';
import OverviewDeviceCardKpi from './OverviewDeviceCardKpi.vue';
import { TranslateResult } from 'vue-i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OverviewDeviceCardKpiList',
  props: {
    width: null,
    leftLabel: null,
    rightLabel: null
  },
  setup(__props: any) {



const isFirstLoad = inject<Ref<boolean>>('isFirstLoad', () => ref(true), true);

return { __sfc: true,isFirstLoad, OverviewDeviceCardKpi }
}

})